import { Button } from "@/components/ui/button";
import { BudgetTargetInput } from "./BudgetTargetInput";

interface BudgetFormProps {
  dailyTarget: string;
  monthlyTarget: string;
  currency: string;
  isLoading: boolean;
  onDailyTargetChange: (value: string) => void;
  onMonthlyTargetChange: (value: string) => void;
  onSave: () => void;
}

export const BudgetForm = ({
  dailyTarget,
  monthlyTarget,
  currency,
  isLoading,
  onDailyTargetChange,
  onMonthlyTargetChange,
  onSave,
}: BudgetFormProps) => {
  return (
    <div className="space-y-4">
      <BudgetTargetInput
        id="daily-target"
        label="Objectif journalier"
        value={dailyTarget}
        currency={currency}
        onChange={onDailyTargetChange}
      />

      <BudgetTargetInput
        id="monthly-target"
        label="Objectif mensuel"
        value={monthlyTarget}
        currency={currency}
        onChange={onMonthlyTargetChange}
      />

      <Button onClick={onSave} className="w-full" disabled={isLoading}>
        {isLoading ? "Enregistrement..." : "Enregistrer les objectifs"}
      </Button>
    </div>
  );
};